import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import getSiteLocationList from "../http/getSiteLocationList";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSiteLocationList = () => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const searchParams = new URLSearchParams(window.location.search);
  const testOrgId: string | null = searchParams.get("testOrgId");

  const fetchSites = useQuery(
    ["getSiteLocationList"],
    async () => {
      return getSiteLocationList(
        await getAuthTokenBlocking(getToken, relogin),
        await getUserOrgId(getClaim, testOrgId ?? undefined)
      );
    },
    { refetchOnWindowFocus: false }
  );

  return {
    siteLocationList: fetchSites.data?.sites,
    fetchSites,
    ...fetchSites,
  };
};

export default useSiteLocationList;
